export default __webpack_public_path__ + "assets/BackArrow.c7c4752a.svg";